<template>
    <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        :src="thumbnail"
        class="img-avatar fix-avatar"
        alt="user avatar" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-item @click="goToUserProfile"><i class="fa fa-user" /> Profile</b-dropdown-item>
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';
export default {
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { user: {}, thumbnail: '/images/avatars/default.jpg' };
  },
  mounted () {
    this.getUserAvatar();
    this.$root.$on('avatar', (avatar) => { // here you need to use the arrow function
      if (avatar) {
        this.thumbnail = avatar;
      }
    });
  },
  methods: {
    logout () {
      localStorage.clear();
      sessionStorage.clear();
      this.$store.dispatch('clearAll', true);
      this.$router.push({ name: 'login' });
    },
    goToUserProfile () {
      this.$router.push({ name: 'userManagement-profile', params: { username: this.user.username } });
    },
    getUserAvatar () {
      this.user = JSON.parse(localStorage.getItem('user') ? localStorage.getItem('user') : sessionStorage.getItem('user'));

      this.axios.get(process.env.VUE_APP_ACCESS_CONTROL_URL + '/user/' + this.user.username)
        .then(response => {
          const userProfile = response.data.data.user;

          if (userProfile.thumbnail) {
            this.thumbnail = userProfile.thumbnail;
          }
        })
        .catch(error => {
          console.log('Error ===>', error.response);
          if (401 === error.response.status) {
            this.logout(); // Expired Token or Unauthorized : Log Out and Redirect to Login Page
          }
        })
        .finally(() => {
        });
    }
  }
};
</script>

<style scoped>
  .fix-avatar{
    width: 40px !important;
    height: 38px !important;
  }
</style>
